(function() {
  const init = function() {
    if (!window.customElements.get("external-video")) {
      // js/custom-element/ui/external-video.js
      var ExternalVideo = class extends CustomHTMLElement {
        constructor() {
          super();
          this.hasLoaded = false;
          (async () => {
            if (this.autoPlay) {
              await this.untilVisible({ rootMargin: "300px", threshold: 0 });
              this.play();
            } else {
              this.addEventListener("click", this.play.bind(this), { once: true });
            }
          })();
        }
        get autoPlay() {
          return this.hasAttribute("autoplay");
        }
        get provider() {
          return this.getAttribute("provider");
        }
        async play() {
          if (!this.hasLoaded) {
            await this._setupPlayer();
          }
          if (this.provider === "youtube") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: "" }), "*");
          } else if (this.provider === "vimeo") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "play" }), "*");
          }
        }
        pause() {
          if (!this.hasLoaded) {
            return;
          }
          if (this.provider === "youtube") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ event: "command", func: "pauseVideo", args: "" }), "*");
          } else if (this.provider === "vimeo") {
            this.querySelector("iframe").contentWindow.postMessage(JSON.stringify({ method: "pause" }), "*");
          }
        }
        _setupPlayer() {
          if (this._setupPromise) {
            return this._setupPromise;
          }
          return this._setupPromise = new Promise((resolve) => {
            const template2 = this.querySelector("template"), node = template2.content.firstElementChild.cloneNode(true);
            node.onload = () => {
              this.hasLoaded = true;
              resolve();
            };
            if (this.autoPlay) {
              template2.replaceWith(node);
              if(node.hasAttribute("data-usercentrics")) {
                new ConsentOverlay(node, node.getAttribute("data-usercentrics"));
              }
            } else {
              this.innerHTML = "";
              this.appendChild(node);
            }
          });
        }
      };
      window.customElements.define("external-video", ExternalVideo);
    }
    if (!window.customElements.get("native-video")) {
      // js/custom-element/ui/native-video.js
      var NativeVideo = class extends HTMLElement {
        constructor() {
          super();
          this.hasLoaded = false;
          if (this.autoPlay) {
            this.play();
          } else {
            this.addEventListener("click", this.play.bind(this), { once: true });
          }
        }
        get autoPlay() {
          return this.hasAttribute("autoplay");
        }
        play() {
          if (!this.hasLoaded) {
            this._replaceContent();
          }
          this.querySelector("video").play();
        }
        pause() {
          if (this.hasLoaded) {
            this.querySelector("video").pause();
          }
        }
        _replaceContent() {
          const node = this.querySelector("template").content.firstElementChild.cloneNode(true);
          this.innerHTML = "";
          this.appendChild(node);
          this.firstElementChild.addEventListener("play", () => {
            this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
          });
          this.firstElementChild.addEventListener("pause", () => {
            this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
          });
          this.hasLoaded = true;
        }
      };
      window.customElements.define("native-video", NativeVideo);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();